import Map from './Components/Map';

document.addEventListener('DOMContentLoaded', () => {
    initMap();
});

const initMap = async () => {
    const mapElement = document.querySelector('#map');

    if (typeof mapElement != 'undefined' && mapElement != null) {
        new Map(mapElement, map_data);
    }
};
